import { render, staticRenderFns } from "./RegisterPackage.vue?vue&type=template&id=a7a0f79e&scoped=true"
import script from "./RegisterPackage.vue?vue&type=script&lang=js"
export * from "./RegisterPackage.vue?vue&type=script&lang=js"
import style0 from "./RegisterPackage.vue?vue&type=style&index=0&id=a7a0f79e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7a0f79e",
  null
  
)

export default component.exports